<vue-breadcrumbs
  [appName]="appName"
  [navSection]="navSection"
  [pageTitle]="pageTitle"
  [enableBack]="enableBack"
></vue-breadcrumbs>
<ng-content></ng-content>
